import { render, staticRenderFns } from "./app-lang.vue?vue&type=template&id=5ae8a8b4&scoped=true&"
import script from "./app-lang.vue?vue&type=script&lang=ts&"
export * from "./app-lang.vue?vue&type=script&lang=ts&"
import style0 from "./app-lang.vue?vue&type=style&index=0&id=5ae8a8b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae8a8b4",
  null
  
)

export default component.exports